import * as React from 'react';
import { Builder, withChildren } from '@builder.io/react';

export interface SectionComponentProps<TSize> {
	readonly size?: TSize;
	readonly children?: React.ReactNode;
}

const register = <TProps extends SectionComponentProps<TSizes[number]>, TSizes extends readonly string[]>(
	Component: React.FC<TProps>,
	options: {
		readonly sizes: TSizes;
		readonly defaultSize?: TSizes[number];
	},
): void => {
	const SectionWithChildren = withChildren(Component);

	Builder.registerComponent(SectionWithChildren, {
		name: 'Core:Section',
		override: true,
		inputs: [
			{
				name: 'size',
				type: 'string',
				required: true,
				enum: Array.from(options.sizes),
				defaultValue: options.defaultSize,
			},
		],
		canHaveChildren: true,

		defaultChildren: [
			{
				'@type': '@builder.io/sdk:Element',
				responsiveStyles: {
					large: {
						textAlign: 'center',
					},
				},
				component: {
					name: 'Text',
					options: {
						text: `
					<p>
						I am a section! My content keeps from getting too wide, so that it's easy to read even on big screens.
					</p>
					`,
					},
				},
			},
		],
	});
};

export default register;
